<template>
    <div class="text-left">
        <label v-if="title" :for="name" class="label-text mt-0">
            <div class="d-flex align-items-center">
                {{ title }} <div v-if="!readonly && required" class="text-danger text-left ml-1">*</div>
            </div>
        </label>
        <label v-else :for="name" class="label-text mt-0">
            <div class="d-flex align-items-center">
                {{ $t(name) }} <div v-if="!readonly && required" class="text-danger text-left ml-1">*</div>

            </div>
            <span class=" " @click="$router.push('/web/sessions/forget_password')"
                v-if="name == 'password' && !noActions">{{
                    $t('forget_password') }}</span>

        </label>
        <b-input-group>
            <template #prepend v-if="name == 'contact_number'">
                {{ $root.country_code }}
            </template>

            <b-form-group v-if="radioKeyList.includes(name)" :required="!readonly">
                <b-form-radio
                    v-model="inputValue"
                    v-for="item in checkNameOptions(name)"
                    :key="`${name}-${item.value}`"
                    :value="item.value"
                    >
                    {{ item.name }}
                </b-form-radio>
            </b-form-group>
            <b-dropdown v-else-if="isOptions" :text="selectedOptionText" class="form-control ">
                <b-dropdown-item v-for="option in selectedOptions" :key="option.value"
                    @click="inputValue = option.value" class="custom-dropdown-item">
                    {{ option.name }}
                </b-dropdown-item>
            </b-dropdown>

            <div v-else-if="type == 'textArea'" class="w-100 d-flex flex-column">
                <textarea name="" class="form-control" style="border-radius: 30px;" id="" cols="30" rows="10"
                    v-model="inputValue" :required="!readonly && required" :readonly="readonly"></textarea>
                <span class="mt-2 label-text">
                    {{ $t("no_symbol") }}
                </span>
            </div>

            <div v-else-if="name == 'gacode'" class="input-wrapper">
                <PincodeInput v-model="inputValue" placeholder="" :length="6" />
            </div>
            <currency-input
                v-if="isMoneyInput"
                v-model="inputValue"
                :options="currencyOptions"
                class="form-control"
                />
            <input v-else-if="!isOptions && !radioKeyList.includes(name) && type !== 'textArea' && !isMoneyInput"
                    class="form-control"
                    :type="inputType"
                    v-model="inputValue"
                    :name="name"
                    :placeholder="name === 'sec_password'
                    ? $t('sec_password_placeholder')
                    : (placeholder.length > 0 ? placeholder : title ? title : $t(name))"
                    :required="!readonly && required"
                    :readonly="readonly"
                    :minlength="name === 'username' ? 5 : null"
                    :maxlength="name === 'username' ? 16 : null"
                />
                <template v-if="showAppend" #append>
                    <span v-if="name == 'use_point1'" class="text-primary font-weight-600" @click="$emit('maxAmount')">
                    {{ $t('max') }}
                    </span>

                    <span v-if="canCopy" class="text-primary font-weight-600" @click="$emit('copyFunction')">
                    <!-- <img src="../assets/images/actions/copy.png" height="24px" alt=""> -->
                    </span>

                    <span v-if="defaultInputType == 'password'" class="ml-1 font-weight-600 text-24" @click="changePasswordType">
                    <img :src="require('../assets/images/action/show.png')" v-if="inputType == 'password'" height="16px" class="mr-2 mt-3"/>
                    <img :src="require('../assets/images/action/hide.png')" v-else height="16px" class="mr-2 mt-3"/>
                    </span>
                </template>
        </b-input-group>
        <div>
            <span
                v-if="name == 'sec_password' && !noActions"
                class="text-primary text-right d-block mt-2 text-14 font-weight-600"
                style="cursor: pointer;"
                @click="showForgetPasswordModal"
                >
                {{ $t('forget_secpassword') }}
            </span>
        </div>
        <div v-if="name == 'use_point1'" class="balance-text">
            {{ $t('available_balance') }}: {{ parseFloat($root.userInfo.point1).toLocaleString() }} USDT
        </div>
        <div v-if="name == 'point2'" class="balance-text">
            {{ $t('available_balance') }}: {{ parseFloat($root.userInfo.point2).toLocaleString() }} USDT
        </div>
    </div>
</template>

<script>
import PincodeInput from 'vue-pincode-input';
import { CurrencyInput } from 'vue-currency-input';
export default {
    components: {
        PincodeInput, CurrencyInput
    },
    props: {
        name: String,
        title: String,
        value: null,
        type: String,
        options: Array,
        placeholder: {
            type: String,
            default: ''
        },
        noActions: {
            type: Boolean,
            default: false
        },
        canCopy: {
            type: Boolean,
            default: false
        },
        label: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: true
        },
        readonly: {
            type: Boolean,
            default: false
        },
        isMoneyInput: {
            type: Boolean,
            default: false
        },
        noDecimal: {
            type: Boolean,
            default: false
        }
    },
    // props: ['name', 'title', 'value', 'readonly', 'noActions', 'options'],
    computed: {
        currencyOptions() {
            return {
            currency: 'MYR', 
            locale: 'en-MY',
            precision: this.noDecimal ? 0 : 2,
            autoDecimalMode: true,
            distractionFree: false
            }
        },
        showAppend() {
            return this.name === 'use_point1' || this.canCopy || this.defaultInputType === 'password';
        },
        selectedOptionText() {
            const selectedOption = this.selectedOptions.find(option => option.value == this.inputValue);
            return selectedOption ? selectedOption.name : 'Select an option';
        },
        ID_typeOptions() {
            return [
                { name: this.$t('national_id'), value: '1' },
                { name: this.$t('passport'), value: '2' },

            ];
        },
        walletTypeOptions() {
            return [
                { name: 'USDT', value: 'USD' },

            ];
        },
        genderOptions() {
            return [
                { name: this.$t('male'), value: '1' },
                { name: this.$t('female'), value: '2' },

            ];
        },
        leverageOptions() {
            return [
                { name: '1:100', value: '100' },
                { name: '1:200', value: '200' },

            ];
        },
    },
    watch: {
        name() {
            this.checkOptions();
            this.checkType();
        },
        value(val) {
            this.inputValue = val;
        },
        inputValue(val) {
            this.$emit('updateInput', val);

        },
        '$root.countryOptions': 'checkOptions',
    },
    data() {
        return {
            inputValue: this.isMoneyInput ? 0 : '',
            selectedOptions: [],
            isOptions: false,
            needIcon: false,
            // required: false,
            defaultInputType: 'text',
            inputType: 'text',
            radioKeyList: ['deposit_method', 'package_type', 'ID_type', 'withdrawal_method', 'trading_type'],
            
        }
    },
    methods: {
        showForgetPasswordModal() {
            this.$bvModal.show('forget_secpassword');
        },
        checkNameOptions(name) {
            var foundVariable;
            const keys = Object.keys(this.$options.computed);
            const matchingKey = keys.find(key => key.includes(name));
            if (matchingKey) {
                foundVariable = this[matchingKey];
            }
            if (this.options) {
                return this.options;

            } else
                return foundVariable;

        },
        changePasswordType() {
            if (this.inputType == 'password')
                this.inputType = 'text';
            else
                this.inputType = 'password';
        },
        checkType() {
            var type = 'text';
            switch (this.name) {
                case 'withdraw_amount_usdt':
                    type = 'number';
                    break;
                case 'lot':
                    type = 'number';
                    break;
                case 'otp':
                    type = 'number';
                    break;
                case 'transfer_amount':
                case 'use_point1':
                    type = 'number';
                    break;
                case 'price':
                    type = 'number';
                    break;
                case 'point2':
                    type = 'number';
                    break;
                case 'dob':
                case 'birthday':
                    type = 'date';
                    break;
                case 'old_password':
                    type = 'password';
                    break;
                case 'sec_password':
                    type = 'password';
                    break;
                case 'email':
                    type = 'email';
                    break;
                case 'password':
                    type = 'password';
                    break;
                case 'password_confirmation':
                    type = 'password';
                    break;
                case 'new_sec_password':
                    type = 'password';
                    break;
                case 'new_account_password':
                    type = 'password';
                    break;
                case 'new_secpwd':
                    type = 'password';
                    break;
                case 'account_password':
                    type = 'password';
                    break;
                case 'confirm_new_secpwd':
                    type = 'password';
                    break;
                case 'new_password':
                    type = 'password';
                    break;
                case 'new_acccount_password_confirmation':
                    type = 'password';
                    break;
                case 'new_password_confirmation':
                    type = 'password';
                    break;
            }
            this.defaultInputType = type;
            this.inputType = type;

        },
        checkOptions() {
            switch (this.name) {
                case 'leverange': 
                    this.isOptions = true;
                    this.selectedOptions = this.leverageOptions;
                    this.inputValue = this.selectedOptions[0].value;
                    break;
                case 'group': 
                    this.isOptions = true;
                    this.selectedOptions = this.accountTypeOptions;
                    this.inputValue = this.selectedOptions[0].value;
                    break;
                case 'gender':
                    this.isOptions = true;
                    this.selectedOptions = this.genderOptions;
                    this.inputValue = this.selectedOptions[0].value;
                    break;
                case 'bank_country':
                    this.isOptions = true;
                    this.selectedOptions = this.$root.countryBankOptions;
                    if (this.selectedOptions.length > 0) {
                        this.inputValue = this.selectedOptions[0].value;
                        this.$root.country_code = this.selectedOptions[0].code;
                    }
                    break;
                case 'country_id':
                    this.isOptions = true;
                    this.selectedOptions = this.$root.countryOptions;
                    if (this.selectedOptions.length > 0) {
                        this.inputValue = this.selectedOptions[0].value;
                        this.$root.country_code = this.selectedOptions[0].code;
                    }
                    break;
                case 'bank_type':
                    this.isOptions = true;
                    this.selectedOptions = this.bankOptions;
                    this.inputValue = this.selectedOptions[0].value;
                    break;
                case 'transfer_type':
                    this.isOptions = true;
                    this.selectedOptions = this.pointOptions;
                    this.inputValue = this.selectedOptions[0].value;
                    break;
                case 'wallet_type':
                case 'currency':
                    this.isOptions = true;
                    this.selectedOptions = this.walletTypeOptions;
                    this.inputValue = this.selectedOptions[0].value;
                    break;
            }

            if (this.options) {
                this.isOptions = true;
                if (this.options.length > 0) {
                    this.selectedOptions = this.options;
                    this.inputValue = this.selectedOptions[0].value;

                }

            }
        }

    },
    mounted() {
        this.checkOptions();
        this.checkType();
        if (this.value !== undefined && this.value !== null && this.value !== '') {
            this.inputValue = this.value;
        } else if (this.isMoneyInput) {
            this.inputValue = 0; 
        }
    }
}
</script>

<style lang="scss">
.vue-pincode-input-wrapper {
    gap: 8px;

    .vue-pincode-input {
        aspect-ratio: 1;
        max-width: 50px !important;
        margin: 0px !important;
        box-shadow: none !important;
        border: 1px solid #ADB5BD !important;
        border-radius: 8px !important;
    }

    .vue-pincode-input:focus {
        border: 3px solid #657BEA !important;
    }

}
.b-input-group > .input-group-append:empty {
  display: none !important;
}
</style>